// Angular
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { LayoutConfigService, ToggleOptions } from '../../../core/_base/layout';
import { HtmlClassService } from '../html-class.service';

@Component({
    selector: 'kt-brand',
    templateUrl: './brand.component.html',
})
export class BrandComponent implements OnInit, AfterViewInit {
    // Public properties
    headerLogo = '';
    brandClasses = '';
    asideSelfMinimizeToggle = true;

    toggleOptions: ToggleOptions = {
        target: 'kt_body',
        targetState: 'aside-minimize',
        toggleState: 'active',
    };

    constructor(private layoutConfigService: LayoutConfigService, public htmlClassService: HtmlClassService) {}

    ngOnInit(): void {
        this.headerLogo = this.getAsideLogo();
        this.brandClasses = this.htmlClassService.getClasses('brand', true).toString();
        this.asideSelfMinimizeToggle = this.layoutConfigService.getConfig('aside.self.minimize.toggle');
    }

    ngAfterViewInit(): void {}

    getAsideLogo() {
        let result = 'whitelogo.png';
        const brandSelfTheme = this.layoutConfigService.getConfig('brand.self.theme') || '';
        if (brandSelfTheme === 'light') {
            result = 'logo-dark.png';
        }
        return `./assets/media/logos/${result}`;
    }

    toggleAsideClick() {
        document.body.classList.toggle('aside-minimize');
    }
}
